import React, { useCallback, useMemo, useState } from 'react';
import { usePrintDispatch } from '@mummssoftware/common-ui';
import { Printing } from '@mummssoftware/utils';
import PatientCertNav from './PatientCertNav';
import { CertPrintDialog } from './CertPrintDialog';

/**
 * Wrapper that provides print and fax handlers via usePrint and passes them to PatientCertNav.
 * Used by PatientCert (class component) so fax context can be consumed here.
 */
export function PatientCertNavWithFax({
  certForm,
  patientHeader,
  setPrintLoading,
  keycloak,
  agency,
  currentUser,
  ...navProps
}) {
  const [printDialogOpen, setPrintDialogOpen] = useState(false);

  const printingService = useMemo(
    () =>
      new Printing({
        url: window.env.hosts.printingService,
        keycloak,
        agency,
        currentUser,
      }),
    [keycloak, agency, currentUser],
  );

  const getFaxPromise = useCallback(
    (faxInstructions, emailInstructions) =>
      printingService.printCertifications(
        [certForm],
        patientHeader,
        certForm.complete,
        faxInstructions,
        undefined,
        emailInstructions,
      ),
    [printingService, certForm, patientHeader],
  );

  const { fax, email } = usePrintDispatch(
    getFaxPromise,
    () => setPrintLoading(true),
    () => setPrintLoading(false),
  );

  return (
    <>
      <PatientCertNav
        {...navProps}
        onPrint={() => {
          if (!certForm || !patientHeader) return;
          setPrintDialogOpen(true);
        }}
        onFax={() => {
          if (!certForm || !patientHeader) return;
          fax();
        }}
        onEmail={() => {
          if (!certForm || !patientHeader) return;
          email();
        }}
      />
      {printDialogOpen && (
        <CertPrintDialog
          certForm={certForm}
          patientHeader={patientHeader}
          printingService={printingService}
          onClose={() => setPrintDialogOpen(false)}
        />
      )}
    </>
  );
}
